import { LitElement, html, css } from "lit-element";

import get from "lodash-es/get";

// language=CSS
export const InputCheckboxListStyle = css`
	:host,
	:host checkbox-list-item {
		display: block;
	}

	:host > label {
		font-size: 13px;
		display: block;
		pointer-events: none;
		white-space: nowrap;
		will-change: transform;
	}

	:host checkbox-list-item > label > input[type="checkbox"] {
		display: none;
	}

	:host checkbox-list-item > label {
		position: relative;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		border-radius: 2px;
		color: var(--app-grey);
	}

	:host checkbox-list-item:first-of-type > label > input-md-decorator {
		border-top: 2px solid var(--app-lightgrey);
	}

	:host checkbox-list-item > label > input-md-decorator {
		-ms-flex: 1 1 0.000000001px;
		-webkit-flex: 1;
		flex: 1;
		-webkit-flex-basis: 0.000000001px;
		flex-basis: 0.000000001px;
		padding: 5px 20px;
		border: 2px solid var(--app-lightgrey);
		border-top: none;

		height: 24px;
		display: block;
	}

	:host checkbox-list-item > label > input[type="checkbox"] + input-md-decorator::after {
		font-weight: bold;

		content: url("data:image/svg+xml;charset=UTF-8, <svg fill='#FFF' height='50' width='50' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'><path d='M27,4,12,19,5,12,0,17,12,29,32,9Z' transform='translate(0 -4)' /></svg>");

		display: block;
		position: absolute;

		right: 20px;
		top: 10px;
		height: 20px;
		width: 20px;

		transition: opacity 0.1s;
		will-change: opacity;
		opacity: 0;
	}

	:host checkbox-list-item > label > input[type="checkbox"]:checked + input-md-decorator {
		color: var(--app-white);
		background-color: var(--app-accent);
	}

	:host checkbox-list-item > label > input[type="checkbox"]:checked + input-md-decorator::after {
		opacity: 1;
	}
`;

export class InputCheckboxList extends LitElement {
	static get properties() {
		return {
			name: { type: String },
			label: { type: String },
			options: { type: Array },
			values: { type: Array }
		};
	}

	constructor() {
		super();
		this.values = [];
	}

	static get styles() {
		return InputCheckboxListStyle;
	}

	render() {
		return html`
			<label>${this.label}</label>
			${this.options &&
				this.options.map(option => {
					return html`
						<checkbox-list-item>
							<label
								><input
									checkbox-list-item
									type="checkbox"
									name="${this.name}[]"
									value="${option.value}"
									?checked="${this.values ? this.values.includes(option.value) : false}"
								/>
								<input-md-decorator>${option.label}</input-md-decorator>
							</label>
						</checkbox-list-item>
					`;
				})}
		`;
	}
}

customElements.define("input-checkbox-list", InputCheckboxList);
